module.exports = __webpack_public_path__ + "img/unpublic.658ffb64.jpg";